export default __webpack_public_path__ + "static/media/brandGuidelinesImagePage31.d898fd7b.png";